import { array, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';
import { Id as ProjectId } from '../../project';

export const Project = struct({
	equalsType: EqualsType,
	values: array(ProjectId),
});
